import * as React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button } from '@bdl-cmn-shared-packages-npm/design-system';
import { style } from './index.style';
import {
	Text,
	ComponentParams,
	ComponentRendering,
	getFieldValue,
} from '@sitecore-jss/sitecore-jss-react';

import { SitecoreGenericTextField } from '../../interfaces';
import { TradingItemCard } from '../TradingItemCard';
import { useState, useEffect } from 'react';
import { fetchData, getMembers } from '../../utils/helper';
import Loader from '../../core/components/Loader/loader.component';
import { breakpointMax } from "../../style";

export interface MainContainerProps {
	fields: any;
	params?: ComponentParams;
	rendering: ComponentRendering;
}

export const MainContainer: React.FunctionComponent<MainContainerProps> = (
	props: MainContainerProps
): React.ReactElement => {
	const { fields, params, rendering } = props;
	const [loading, setLoading] = useState<boolean>(true);
	const [members, setMembers] = useState<any[]>([]);
	const [visibleMembersCount, setVisibleMembersCount] = useState<number>(8); // Initialiser avec 8

  const isListing: boolean = getFieldValue<boolean>(
    fields,
    "display listing members",
    false
  );
  const isTrading: boolean = getFieldValue<boolean>(
    fields,
    "display trading members",
    false
  );
  const isLuxSEPartner: boolean = getFieldValue<boolean>(
    fields,
    "display LuxSE Partners",
    false
  );
  const isIndependentSoftwareVendor: boolean = getFieldValue<boolean>(
    fields,
    "display independent software vendors",
    false
  );
  const isTransitionFinanceDataProvider: boolean = getFieldValue<boolean>(
    fields,
    "display transition finance data providers",
    false
  );  

  const container = css`
    width: 100%;
    background: ${isTransitionFinanceDataProvider ? "linear-gradient(82.4deg, #F5F5FF 0.08%, #EBFCF5 99.36%)" : ""};
    max-width: ${isTransitionFinanceDataProvider ? "" : "1280px"};
    padding-left: 40px;
    padding-right: 40px;
    margin: auto;
    min-height: 600px;
  `;
  const title = css`
    width: 100%;
    max-width: 800px;
    text-align: center;
    display: flex;
    justify-content: center;
    font-weight: 800;
    font-size: 48px;
    line-height: 61px;
    color: #122834;
    margin: 48px auto;
    padding-top: ${isTransitionFinanceDataProvider ? "40px" : ""};
      @media (max-width: ${breakpointMax}) {
        font-weight: 700;
        font-size: 24px;
        line-height: 31px;
        text-align: center;
      }
  `;
  const center = css`
    max-width: ${isTransitionFinanceDataProvider ? "1280px" : ""};
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${isTransitionFinanceDataProvider ? "auto" : ""};
  `;

  const fetchElements = async (id: string) => {
    try {
      const result: any = await fetchData(id);
      const res = await getMembers(result);
      if (isListing) {
        setMembers(
          res.filter((res: any) => res["Is listing member"] === "1") || []
        );
      } else if (isTrading) {
        setMembers(
          res.filter((res: any) => res["Is trading member"] === "1") || []
        );
      } else if (isLuxSEPartner) {
        setMembers(
          res.filter((res: any) => res["Is LuxSE Partner"] === "1") || []
        );
      } else if (isIndependentSoftwareVendor) {
        setMembers(
          res.filter((res: any) => res["Is independent software vendor"] === "1") || []
        );
      } else if (isTransitionFinanceDataProvider) {
        setMembers(
          res.filter((res: any) => res["Is transition finance data provider"] === "1") || []
        );
      }

			setLoading(false);
		} catch (err) {
			console.error(err);
		}
	};

	useEffect(() => {
		fetchElements('877380A7-A456-4E75-B56C-C6FE8D79BB88');
	}, []);

	const loadMoreMembers = () => {
		setVisibleMembersCount(prevCount => prevCount + 8); // Augmenter de 8
	};

	return (
		<div css={container}>
			<div css={title}>
				<Text field={fields && (fields.title as SitecoreGenericTextField)} />
			</div>
			<Loader loading={loading}>
				<div css={center}>
					<div css={style.rows}>
						{members.slice(0, visibleMembersCount).map((member: any, index: number) => (
							<TradingItemCard member={member} key={`index-${index}`} />
						))}
					</div>
					{members.length > visibleMembersCount && (
						<div css={style.rowButton}>
							<Button
								label="Show more entries"
								onClick={loadMoreMembers}
							/>
						</div>
					)}
				</div>
			</Loader>
		</div>
	);
};